import axios from 'axios';
import { message } from 'ant-design-vue';

import store from '../store';
import { baseUrl } from '@/utils/constants';
import router from '../router';
import i18n from '../lang';

axios.defaults.baseURL = baseUrl;
axios.defaults.timeout = 100000;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const showMessage = (msg, callback?: any) => {
  message.destroy();
  message.error(msg, 1, () => callback && callback());
};

const toLoginPage = async () => {
  await store.dispatch('clearLoginInfo');
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.value.fullPath
    }
  });
};

const errorHandle = (status, message) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLoginPage();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      showMessage(i18n.global.t('error.expire'), toLoginPage);
      break;
    // 404请求不存在
    case 404:
      showMessage(i18n.global.t('error.source_not_exist'));
      break;
    case 500:
      if (message && message.indexOf('401') >= 0) {
        showMessage(i18n.global.t('error.expire'), toLoginPage);
      } else {
        showMessage(
          (message && i18n.global.t(message)) || i18n.global.t('error.unknown')
        );
      }

      break;
    default:
      showMessage(
        (message && i18n.global.t(message)) || i18n.global.t('error.unknown')
      );
  }
};

axios.interceptors.request.use(
  config => {
    const token = store.state.access_token;
    if (token) {
      config.headers['X-Access-Token'] = token;
    }
    const key = store.state.access_key;
    if (key) {
      config.headers['X-Access-Key'] = key;
    }
    const lang = store.state.lang;

    if (lang) {
      config.headers['Accept-Language'] = lang.replace('_', '-');
    }
    if (config.url && config.url.indexOf('ureport/excel') > 0) {
      config.baseURL = '';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  res => {
    if ([500, 510].includes(res.data.code) && res.data.message) {
      message.error(i18n.global.t(res.data.message), 2);
    }
    return Promise.resolve(res);
  },
  err => {
    if (err.response) {
      errorHandle(err.response.status, err.response.data.message);
      return Promise.reject(err.response);
    } else {
      if (!window.navigator.onLine) {
        store.commit('changeNetwork', false);
      } else {
        return Promise.reject(err);
      }
    }
  }
);

//get 请求
export function getAction(url, params?: any) {
  return new Promise<any>((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

// post请求
export function postAction(url, params) {
  return new Promise<any>((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

// post请求
export function putAction(url, params) {
  return new Promise<any>((resolve, reject) => {
    axios
      .put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

// delete
export function deleteAction(url, params) {
  return new Promise<any>((resolve, reject) => {
    axios
      .delete(url, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

// download
export function downFile(url, parameter) {
  return axios({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  });
}

export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then(({ data }) => {
    if (!data || data.size === 0) {
      message.warning(i18n.global.t('error.download_failed'));
      return;
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName);
    } else {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); //下载完成移除元素
      window.URL.revokeObjectURL(url); //释放掉blob对象
    }
  });
}
